var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-results container" }, [
    _c(
      "div",
      { staticClass: "search-results__inner-wrapper" },
      [
        _c("h1", { staticClass: "search-results__header" }, [
          _vm._v("Search for products on our site")
        ]),
        _c("text-input", {
          staticClass: "search-results__text-input",
          attrs: {
            label: "Search all products",
            "hide-label": true,
            placeholder: "Search all products"
          },
          model: {
            value: _vm.searchTerm,
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        }),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.hasSearch
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "search-results__grid-header" }, [
                    _c("p", { staticClass: "search-results__product-count" }, [
                      _vm._v(
                        _vm._s(_vm.searchResults.length) +
                          ' results for "' +
                          _vm._s(_vm.searchTerm) +
                          '"'
                      )
                    ])
                  ]),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.searchResults.length > 0
                      ? _c(
                          "div",
                          { staticClass: "search-results search-results" },
                          [
                            _c(
                              "div",
                              { staticClass: "row small-up-1 medium-up-4" },
                              _vm._l(_vm.searchResults, function(item) {
                                return _c(
                                  "div",
                                  { staticClass: "column" },
                                  [
                                    _c("product-tile", {
                                      attrs: {
                                        product: item,
                                        "tile-color": _vm.tileColor
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }